
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.99 19.024l-.288 2.311a.77.77 0 01-.763.677h-3.744v9.664a13.34 13.34 0 01-3.84-.209v-9.454h-2.88a.482.482 0 01-.479-.482v-2.892c0-.265.216-.482.48-.482h2.88v-4.338c0-2.662 2.148-4.819 4.8-4.819h3.358c.265 0 .48.217.48.482v2.892a.483.483 0 01-.48.482h-2.4c-1.059 0-1.918.863-1.918 1.928v3.374h4.03c.463 0 .822.407.764.867z","fill":"#fff"}}),_c('path',{attrs:{"d":"M31.439 40H8.56C3.841 40 0 36.159 0 31.439V8.56C0 3.841 3.841 0 8.561 0H31.44C36.159 0 40 3.841 40 8.561V31.44C40 36.159 36.159 40 31.439 40zM8.56 1.557A7.012 7.012 0 001.557 8.56V31.44a7.012 7.012 0 007.004 7.004H31.44a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H8.56z","fill":"#fff"}})])
          )
        }
      }
    